import { render, staticRenderFns } from "./TriggeredReferral.vue?vue&type=template&id=709ba278&scoped=true&"
import script from "./TriggeredReferral.vue?vue&type=script&lang=js&"
export * from "./TriggeredReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ba278",
  null
  
)

export default component.exports